import { useContext } from "react"
import {AuthContext} from '../contexts/auth'

const Navbar = () => {


    const { user, logout } = useContext(AuthContext)

    return (
        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                <i className="fa fa-bars"></i>
            </button>

            <ul className="navbar-nav ml-auto">

                <li className="nav-item no-arrow">
                    <span className="mr-2 d-none nav-link d-lg-inline text-gray-600 small">Bem vindo Dr. {user.name}!</span>
                </li>

            </ul>

        </nav>
    )
}

export default Navbar
